import React, { Component } from "react";
import "./createDocumentModal.css";
import "./office.css";

import { uploadOfficeRedux, updateOfficeRedux } from "../../../actions/index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
class CreateDocumentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      address: "",
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { office } = nextProps;
    console.log(office);
    console.log("create Lot modal component will receive props is called");
    if (office != null) {
      this.setState(
        {
          name: office.name,
          address: office.address,
        },
        () => {
          console.log(this.state);
        }
      );
    } else {
      this.setState({
        name: "",
        address: "",
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(this.state);
    console.log(this.props.office);
    if (this.props.office === null) {
      await this.props.uploadOfficeRedux({
        address: this.state.address,
        name: this.state.name.replaceAll("_", "-"),
        officeId: this.state.name.replaceAll("_", "-"),
      });
      toast.success(`Successfully created office ${this.state.name}`);
    } else {
      await this.props.updateOfficeRedux({
        ...this.state,
        officeId: this.state.name,
      });
      toast.success(`successfully updated office ${this.state.name}`);
    }

    this.setState({
      name: "",
      address: "",
    });
    this.props.startToggleModal(null);
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    console.log(this.props.office);
    return (
      <>
        <div
          className={
            this.props.toggleModal
              ? "modal fade show of-page tb-modal"
              : "modal fade show visible-modal of-page tb-modal"
          }
          id="request_popup"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered request_popup"
            role="document"
          >
            <div className="modal-content of-modal-content">
              <div className="modal-body p-0">
                <div className="of-modal-body-inner" style={{ position: "relative" }}>
                  <span
                    onClick={() => this.props.startToggleModal(null)}
                    className="of-modal-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="icofont-close-line"></i>
                  </span>

                  <div className="of-modal-stamp of-stamp-font">
                    {!this.props.office ? "New office" : "Edit office"}
                  </div>
                  <div className="of-modal-icon-chip">
                    <i className="icofont-building-alt"></i>
                  </div>
                  <div className="of-modal-title">
                    {!this.props.office
                      ? "Create New Office"
                      : "Update Office"}
                  </div>

                  <form onSubmit={this.handleSubmit} noValidate="novalidate">
                    <div className="of-field">
                      <label className="of-label">Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control of-input"
                        placeholder="Office name"
                        onChange={this.handleChange}
                        value={this.state.name}
                        required
                        readOnly={this.props.office ? true : false}
                      />
                    </div>
                    <div className="of-field">
                      <label className="of-label">Address</label>
                      <input
                        type="text"
                        required
                        name="address"
                        className="form-control of-input"
                        placeholder="Office Address"
                        onChange={this.handleChange}
                        value={this.state.address}
                      />
                    </div>

                    <div className="form-row">
                      <div
                        className="col pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button type="submit" className="btn of-submit-btn">
                          {this.props.office == null
                            ? "Create Office"
                            : "Update Office"}
                          <i className="icofont-rounded-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  uploadOfficeRedux,
  updateOfficeRedux,
})(CreateDocumentModal);
